/* eslint-disable react/prop-types */
import React from 'react';
// our components
import {
  ServerError,
  PermissionDeniedError,
  IpNotAllowed,
} from 'helpers/errors';
import ErrorView from 'helpers/errorViewHelper';

/**
 * @class
 * @extends React.Component
 */
class GraphqlErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  /**
   * @description
   * React lifecycle method to update state when catch errors.
   *
   * @param {Object} error - Error.
   * @param {Object} errorInfo - Error info.
   */
  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error, errorInfo) {
    if (error.displayName === ServerError.displayName) {
      this.setState({ error: ServerError.displayName });
    } else if (error.displayName === PermissionDeniedError.displayName) {
      this.setState({ error: PermissionDeniedError.displayName });
    } else if (error.displayName === IpNotAllowed.displayName) {
      this.setState({ error: IpNotAllowed.displayName });
    }
  }

  /**
   * @description
   * Render GraphQL errors.
   * @returns {*} Children component or error.
   */
  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error === ServerError.displayName) {
      return <ErrorView />;
    }
    if (error === PermissionDeniedError.displayName) {
      return <ErrorView message="Permiso denegado" />;
    }
    if (error === IpNotAllowed.displayName) {
      return <ErrorView message="Dirección IP no autorizada" />;
    }
    return children;
  }
}

export default GraphqlErrorBoundary;
